import { useEffect } from 'react';
import { useSuiClientContext } from '@mysten/dapp-kit';
import { registerEnokiWallets, isEnokiNetwork } from '@mysten/enoki';

/**
 * 註冊 Enoki 錢包組件
 * 必須在 WalletProvider 之前渲染
 */
export default function EnokiWalletRegistration() {
    const { client, network } = useSuiClientContext();

    useEffect(() => {
        // 檢查是否為支持的 Enoki 網路
        if (!isEnokiNetwork(network)) {
            console.warn(`Network ${network} is not supported by Enoki`);
            return;
        }

        const apiKey = process.env.REACT_APP_ENOKI_PUBLIC_KEY;

        if (!apiKey) {
            console.error('REACT_APP_ENOKI_PUBLIC_KEY is not set');
            return;
        }

        console.log('Registering Enoki wallets for network:', network);

        try {
            // 註冊 Enoki 錢包
            const { unregister } = registerEnokiWallets({
                apiKey,
                network,
                client: client,
                providers: {
                    // 從環境變數讀取 Google Client ID
                    google: {
                        clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
                    },
                },
            });

            console.log('✅ Enoki wallets registered successfully');

            // 清理函數
            return () => {
                console.log('Unregistering Enoki wallets');
                unregister();
            };
        } catch (error) {
            console.error('❌ Failed to register Enoki wallets:', error);
        }
    }, [client, network]);

    return null;
}
